import { useTranslation } from "react-i18next";
import { Users as UsersIcon } from "lucide-react";

interface UsersListEmptyProps {
  readonly hasFilters: boolean;
}

export function UsersListEmpty({ hasFilters }: UsersListEmptyProps) {
  const { t } = useTranslation();
  return (
    <div
      data-testid={hasFilters ? "users-list-no-results" : "users-list-empty"}
      className="rounded-lg border border-dashed border-border bg-card p-10 text-center"
    >
      <UsersIcon className="mx-auto mb-3 h-8 w-8 text-muted-foreground" aria-hidden="true" />
      <p className="font-sans text-base font-medium text-foreground">
        {hasFilters ? t("users.empty.filteredTitle") : t("users.empty.title")}
      </p>
      <p className="mt-1 font-sans text-sm font-normal text-muted-foreground">
        {hasFilters ? t("users.empty.filteredBody") : t("users.empty.body")}
      </p>
    </div>
  );
}
